import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

const IMG_URL = '/static/images/about/v2/join-bg';

const Join = () => {
    return (
        <ST.Join indent={{ $desktop: [48, 80], $mobile: [16] }} rounder={{ $desktop: 32, $mobile: 24 }} bgColor={`${COLORS.Outline_Dark}33`}>
            <ST.ImageWrapper>
                <WebpImage urlWebp={`${IMG_URL}.webp`}>
                    <img src={`${IMG_URL}.png`} alt='Изображение работы компании' />
                </WebpImage>
            </ST.ImageWrapper>
            <ST.SFullWidthListContainer $size={64} $direction='column'>
                <ST.Title>Присоединяйтесь к&nbsp;нашей команде</ST.Title>
                <ST.Link href='https://job.ertelecom.ru/' target='_blank' rel='noreferrer'>
                    <ButtonGroup>
                        <Button bType='primary'>
                            Посмотреть вакансии
                        </Button>
                    </ButtonGroup>
                </ST.Link>
            </ST.SFullWidthListContainer>
        </ST.Join>
    );
};

export default Join;
